import { Injectable } from '@angular/core';

import { DATEFORMATS } from '@store';

import { TranslationConfigService } from './translation-config.service';

@Injectable({
  providedIn: 'root',
})
export class DateTimeService {
  constructor(private translationConfig: TranslationConfigService) {}

  public getFormat(): string {
    const format = DATEFORMATS[this.getLocale()];

    return !!format ? format : 'DD/MM/YYYY';
  }

  public getLocale(): string {
    return this.translationConfig.getLanguage();
  }
}
